import clsx from 'clsx'
//import './styles.scss'

import React, { ReactNode, useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

type InputTextProps = {
	label: string
	error?: string
	onButtonClick?: React.MouseEventHandler<HTMLButtonElement>
	buttonLabel?: string
	type?: 'text' | 'month' | 'date' | 'number' | 'file' | 'email'
	removeWhitespaces?: boolean
	preventCopyPaste?: boolean
	additionalMessage?: ReactNode
} & React.InputHTMLAttributes<HTMLInputElement>

const InputText = React.forwardRef<HTMLInputElement, InputTextProps>(
	(
		{
			label,
			required,
			error,
			onButtonClick,
			className,
			type = 'text',
			buttonLabel = 'OK',
			removeWhitespaces = false,
			preventCopyPaste = false,
			additionalMessage,
			...props
		},
		ref
	) => {
		const formContext = useFormContext()
		const watch = formContext?.watch(props.name ?? '')
		const inptRef = useRef<HTMLInputElement>(null)

		useEffect(() => {
			if (removeWhitespaces && watch) {
				formContext?.setValue(props.name ?? '', watch.replace(/\s/g, ''))
			}
		}, [watch])

		useEffect(() => {
			if (preventCopyPaste && inptRef && inptRef.current) {
				inptRef.current.addEventListener('paste', (e) => {
					e.preventDefault()
				})
			}
		}, [])

		return (
			<div
				className={clsx(`input-text__container ${className ?? ''}`, {
					// 'remove-outline': outline,
				})}
				ref={inptRef}
			>
				<div className='input-text__wrapper'>
					<input
						{...props}
						placeholder=' '
						ref={ref}
						type={type}
						max={'9999-12-31'}
						min={0}
						className={clsx('input-text', {
							'input-text--no-round': onButtonClick,
							'input-text--border': type === 'file',
							'input-text--no-calendar': type === 'month' || type === 'date',
						})}
					/>
					<label className='input-text__label'>
						{label}{' '}
						{required && <span className='input-text--required'>*</span>}
					</label>
					{type === 'date' && (
						<div className='calendar'>
							<img src='/assets/images/calendario.png' alt='calendar' />
						</div>
					)}
					{onButtonClick && (
						<button
							type='button'
							className='input-text--button'
							onClick={onButtonClick}
						>
							{buttonLabel}
						</button>
					)}
				</div>
				{type !== 'file' && (
					<span className='input-text--error'>
						{error ?? ' '}
						{additionalMessage ?? null}
					</span>
				)}
			</div>
		)
	}
)

export default InputText
